<div class="category_content">
  <div class="p-fluid grid w-100 category_search">
    <div class="col-10">
      <input
        type="text"
        pInputText
        placeholder="Pesquise pela descrição"
        class="w-full"
      />
    </div>
    <div class="col-2">
      <button
        type="button"
        pButton
        label="Criar Categoria"
        icon="pi pi-plus-circle"
        severity="success"
        (click)="toggleDialog()"
      ></button>
    </div>
  </div>

  <ng-container *ngIf="pagination.data?.length; else noData">
    <p-table
      [value]="pagination.data || []"
      [loading]="loading"
      stripedRows
      responsiveLayout="scroll"
      class="categoria-table"
    >
      <ng-template pTemplate="header">
        <tr>
          <th>Descrição</th>
          <th>Data de Criação</th>
          <th>Data de Atualização</th>
          <th>Estado</th>
          <th class="text-center">Ações</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-categoria>
        <tr (click)="editCateforia(categoria)" class="cursor-pointer">
          <td>{{ categoria.descricao }}</td>
          <td>{{ categoria.dataCriacaoFormatada }}</td>
          <td>{{ categoria.dataAtualizacaoFormatada }}</td>
          <td>
            <p-tag
              [value]="categoria.ativo ? 'Ativo' : 'Inativo'"
              [severity]="getSeverity(categoria.ativo)"
            ></p-tag>
          </td>
          <td class="text-center">
            <p-menu
              #menuRef
              [model]="getMenuActions(categoria)"
              [popup]="true"
              appendTo="body"
            ></p-menu>
            <p-button
              icon="pi pi-ellipsis-v"
              [rounded]="true"
              [text]="true"
              severity="success"
              (click)="toggleMenu($event, menuRef)"
            ></p-button>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="5">
            <app-data-void
              message="Nenhuma categoria encontrada"
            ></app-data-void>
          </td>
        </tr>
      </ng-template>
    </p-table>

    <div class="pagination-controls">
      <app-paginator-control
        [first]="
          ((pagination.pageNumber ?? 1) - 1) * (pagination.pageSize ?? 10)
        "
        [rows]="pagination.pageSize ?? 10"
        [totalRecords]="pagination.totalRecords ?? 0"
        (pageChange)="onPageChange($event)"
      >
      </app-paginator-control>
    </div>
  </ng-container>
  <ng-template #noData>
    <div class="no-data">
      <app-data-void
        titulo="Nenhuma categoria encontrada"
        descricao="Clique em Criar Categoria para cria uma nova!"
      />
    </div>
  </ng-template>
</div>

<!-- Adicionar nova categoria -->
<p-dialog
  [header]="IsEditMode ? 'Editar categoria' : 'Adicionar Categoria'"
  [modal]="true"
  [(visible)]="showCreateDialog"
  [style]="{ width: '30rem' }"
>
  <form [formGroup]="categoriaForm" class="p-fluid grid">
    <div class="col-12 field flex flex-column gap-2">
      <label for="descricao">Descrição</label>
      <input
        type="text"
        pInputText
        placeholder="Informe o nome da categoria"
        class="w-full"
        formControlName="descricao"
        (invalid)="isInvalid('descricao')"
      />
      <small class="error" *ngIf="isInvalid('descricao')"
        >Categoria é obrigatória.</small
      >
    </div>

    <div class="flex justify-content-between gap-2 col-12">
      <p-button
        label="Cancelar"
        severity="secondary"
        (click)="toggleDialog()"
      />
      <button
        class="btn_one"
        (click)="IsEditMode ? UpdateCategoria() : saveCategory()"
        [disabled]="loading"
      >
        {{ loading ? "Guardando..." : "Guardar" }}
        <i class="pi pi-spinner" *ngIf="loading"></i>
      </button>
    </div>
  </form>
</p-dialog>
